import React from "react";

import COASave from "../ConfirmSave/COASave";
import TemplateSave from "../ConfirmSave/TemplateSave";
import DataFieldsSection from "./DataFieldsSection";
import TextBoxSection from "./TextBoxSection";
import "./builderComponents.css";

export default function BuilderComponents(props) {
  const {
    previewTemplate,
    commonDataFieldsInUse,
    customizedDataFieldsInUse,
    setAllCustomizedDataFields,
    setAllDataFields,
    allDataFields,
    isCustomizingCoa,
    handleSaveTemplate,
    selectedTemplate,
    selectedReports,
    saveStatus,
    setSaveStatus,
    isReadOnlyCoaTemplate,
    coaName,
    onCoaNameChange,
    coaNameError,
    onCoaNameErrorChange,
  } = props;
  const disableCoaSave = previewTemplate && !isReadOnlyCoaTemplate;
  return (
    <div className="builderComponents">
      {isCustomizingCoa ? (
        <>
          {!isReadOnlyCoaTemplate && (
            <DataFieldsSection
              previewTemplate={previewTemplate}
              commonDataFieldsInUse={commonDataFieldsInUse}
              customizedDataFieldsInUse={customizedDataFieldsInUse}
              setAllCustomizedDataFields={setAllCustomizedDataFields}
              setAllDataFields={setAllDataFields}
              allDataFields={allDataFields}
            />
          )}
          <div className={disableCoaSave ? "templateBuilderDisableSection" : ""}>
            <COASave
              inline
              handleSaveTemplate={handleSaveTemplate}
              selectedReports={selectedReports}
              selectedTemplate={selectedTemplate}
              setSaveStatus={setSaveStatus}
              saveStatus={saveStatus}
              coaName={coaName}
              onCoaNameChange={onCoaNameChange}
              coaNameError={coaNameError}
              onCoaNameErrorChange={onCoaNameErrorChange}
            />
          </div>
        </>
      ) : (
        <>
          <TextBoxSection
            previewTemplate={previewTemplate}
          />
          <div className={previewTemplate ? "templateBuilderDisableSection" : ""}>
            <TemplateSave
              inline
              handleSaveTemplate={handleSaveTemplate}
              selectedTemplate={selectedTemplate}
              setSaveStatus={setSaveStatus}
              saveStatus={saveStatus}
            />
          </div>
        </>
      )}
    </div>
  );
}
